import { useSelector, useDispatch } from "react-redux";
import { useCallback } from "react";
import { setProgressData } from "../store/progressData/progressDataSlice";

export const useProgress = () => {
  const dispatch = useDispatch();
  const progressData = useSelector((state) => state?.progressdata?.progress);

  const progressFunction = useCallback(() => {
    if (progressData === 100) {
      dispatch(setProgressData(0));
    }
  }, [progressData, dispatch]);

  return { progressFunction, progressData };
};